import { render, staticRenderFns } from "./cuentas-bancarias.vue?vue&type=template&id=78625fd0&"
import script from "./cuentas-bancarias.component.ts?vue&type=script&lang=ts&"
export * from "./cuentas-bancarias.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports